import * as React from "react";
import clsx from "clsx";
import { default as ReactDatePicker } from "react-datepicker";
import { IDatePickerProps } from "./DatePicker.types";

if (document !== undefined) {
    //@ts-ignore
    require("react-datepicker/dist/react-datepicker.css");
}

const DatePicker: React.FC<IDatePickerProps> = ({
    value,
    onChange,
    errorMessage,
    label,
    labelContent,
    name,
    DatePicker,
    wrapper,
    classes = {},
    ...props
}) => {
    if (errorMessage) {
        classes.input_container = clsx("tmp-input-error", classes.input_container);
    }

    return (
        <div className={clsx(classes.label, ["tmp-label", "tmp-datepicker"])} {...wrapper}>
            <div className="tmp-label-text">
                {label}
                {labelContent?.()}
            </div>
            <div className={clsx(classes.input_container, ["tmp-input-container"])}>
                <ReactDatePicker
                    selected={value}
                    onChange={onChange}
                    {...DatePicker}
                    data-name={name}
                    className={clsx(classes.input, ["tmp-input"])}
                />
            </div>
            {errorMessage ? <div className="tmp-input-error-message">{errorMessage}</div> : ""}
        </div>
    );
};

export default DatePicker;
